module.exports = __webpack_public_path__ + "static/DattiloDJRBannerVariable-VF-a3b85836809c8167a8bda95f801ff1fd.woff";